import type { KimLhcCategories } from '@/types';
import { KimLhcCategoryKey } from '@/types';
import type { CategoryScore } from '@/components/views/Report/KimLhc/Report/Steps/Result/Constants';

type KimLhcCategoryKeyType = KimLhcCategoryKey;

export interface ScoreData {
	score: number;
	maxScore: number;
	label: string;
}

type CategoryScoreStrategy = (categories: KimLhcCategories, category: CategoryScore) => ScoreData[];

const createSingleScore = (score: number, maxScore: number): ScoreData[] => [{ score, maxScore, label: 'Score:' }];

const strategies: Record<KimLhcCategoryKeyType, CategoryScoreStrategy> = {
	[KimLhcCategoryKey.FREQUENCY]: (categories, category) =>
		createSingleScore(categories.frequency.score, category.maxScore),

	[KimLhcCategoryKey.WEIGHT]: (categories, category) => [
		{
			score: categories.weight.manScore,
			maxScore: category.manMaxScore ?? 100,
			label: category.manScoreKey ?? 'Score men:'
		},
		{
			score: categories.weight.womanScore,
			maxScore: category.womanMaxScore ?? 100,
			label: category.womanScoreKey ?? 'Score women:'
		}
	],

	[KimLhcCategoryKey.CARGO_HANDLING_CONDITION]: (categories, category) =>
		createSingleScore(categories.cargoHandlingCondition.score, category.maxScore),

	[KimLhcCategoryKey.POSTURE]: (categories, category) =>
		createSingleScore(
			categories.posture.score,
			category.maxScore
		),

	[KimLhcCategoryKey.WORK_CONDITION]: (categories, category) =>
		createSingleScore(
			categories.workCondition.score,
			category.maxScore
		),

	[KimLhcCategoryKey.WORK_ORGANIZATION]: (categories, category) =>
		createSingleScore(
			categories.workOrganization.score,
			category.maxScore
		)
};

export function getCategoryScores(
	contentKey: KimLhcCategoryKeyType,
	categories: KimLhcCategories,
	category: CategoryScore
): ScoreData[] {
	return strategies[contentKey](categories, category);
}
